// extracted by mini-css-extract-plugin
module.exports = {"container":"document-teaser-module--container--3HGMN","imageColumn":"document-teaser-module--imageColumn--2u1PX","textColumn":"document-teaser-module--textColumn--22UVe"};